<template>
  <div class="add-visit-person">
    <title-bar
      :title="
        isEdit
          ? $t('Gattaran_0_Edit_contacts_nCLZ' /** 编辑联系人 */)
          : $t('Gattaran_0_Create_new_Faau' /** 新建联系人 */)
      "
      show-back
      @back="back"
    />
    <div class="add-visit-person-list-wrapper">
      <soda-form
        v-if="dataLoaded"
        ref="form"
        v-model="formData"
        class="add-visit-person-form"
        :config="formConfig"
      />
    </div>
    <div class="save">
      <rich-button class="save-btn" :loading="loading" @click="save">
        <span>{{ gettext('保存') }}</span>
      </rich-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from '@/components/TitleBar'
import SodaForm from '@/components/form/index'
import { mapState } from 'vuex'
import daphne from '@didi/daphne-sdk-javascript'
import ruleConfig from '@/common/utils/rules-COM'
import { i18n, sprintf } from '@/common/utils/i18n'
import { getVisitObjectInit, saveVisitObject } from '../service.js'
const nI18n = {
  gettext: i18n.gettext,
  sprintf
}
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  name: 'AddBrandVisitPerson',
  components: {
    TitleBar,
    SodaForm
  },
  props: {
    roleId: {
      required: false,
      type: Number
    },
    id: {
      required: false,
      type: Number
    },
    onlyId: {
      type: [Number, String],
      default() {
        return 0
      },
    },
    brandId: {
      type: String,
      default: '',
    },
    isEdit: {
      required: true,
      type: Boolean
    },
    options: {}
  },
  data () {
    return {
      loading: false,
      dataLoaded: false,
      shopId: this.$route.query.shopId,
      formData: {},
      visitObjectList: [],
      phonePreText: '',
    }
  },
  computed: {
    ...mapState(['login']),
    ...mapState('visitV2', ['visitBrand']),
    roleList () {
      const list = this.options.roleId?.enum
      return list.length > 0
        ? list.map(i => ({ value: i.value, text: i.label }))
        : []
    },
    contactModeList () {
      return this.options.contactMode.enum
    },
    formConfig () {
      const emailRule = ruleConfig.email('', nI18n)
      const phoneRule = ruleConfig.telePhone('', nI18n)
      return [
        {
          label: this.$t('Gattaran_0_Role_QDBu' /** 角色 */),
          type: 'rich-select',
          prop: 'roleId',
          props: {
            disabled: this.isEdit,
            options: this.availableRoleList,
            placeholder: this.gettext('请选择')
          },
          rules: {
            required: true
          }
        },
        {
          label: this.gettext('姓名'),
          type: 'input',
          prop: 'name',
          props: {
            placeholder: this.gettext('请输入')
          },
          rules: {
            required: true
          }
        },
        {
          label: this.gettext('电话'),
          type: 'phone',
          prop: 'phone',
          props: {
            placeholder: this.gettext('请输入'),
            preText: this.phonePreText
          },
          rules: {
            ...phoneRule.rules,
            required: this.formData.roleId !== 50,
            type: 'string'
          },
          messages: phoneRule.messages
        },
        {
          label: this.$t('FoodB_email_CBNM_cSdr' /** 邮箱 */),
          type: 'input',
          prop: 'email',
          props: {
            placeholder: this.gettext('请输入')
          },
          rules: {
            // type: 'email',
            ...emailRule.rules
          },
          messages: emailRule.messages
        },
        {
          label: this.$t('FoodB_leads_The_relationship_jkYA' /** 倾向联系时间 */),
          type: 'timeRangePicker',
          prop: 'contactTime',
          props: {
            placeholder: this.gettext('请选择')
          },
          rules: {
            custom: (val) => {
              if (!val[0] || !val[1]) {
                return true
              } else {
                const start = +new Date(`1970/01/01 ${val[0]}`)
                const end = +new Date(`1970/01/01 ${val[1]}`)
                return start < end
              }
            }
          },
          messages: {
            custom: this.$t('Gattaran_0_The_end_KvBf' /** 结束时间必须大于开始时间 */)
          }
        },
        {
          label: this.$t('FoodB_optimization_Stimulate_contact_xSSH' /** 倾向联系方式  */),
          type: 'multiSelectNew',
          prop: 'contactMode',
          props: {
            options: this.contactModeList,
            placeholder: this.gettext('请选择')
          }
        }
      ]
    },
    availableRoleList () {
      const existedRoleIds = this.visitObjectList.map(i => i.roleId)
      return this.isEdit
      ? this.roleList
      : this.roleList.filter((role) => {
          const count = existedRoleIds.filter((id) => id === role.value).length
          if (role.value === 50) {
            return count < 2 // roleId=50 最多选 2 次
          } else {
            return count < 1 // 其他角色最多选 1 次
          }
        })
    }
  },
  watch: {
    formData: {
      handler (newVal) {
        console.log('newVal =========>', newVal)
      }
    }
  },
  async mounted () {
    const loading = this.$createToast({ mask: true })
    loading.show()
    // 获取callingCode配置
    const { country } = this.login.userInfo
    const callingCode = daphne.getCallingCode(country)
    this.phonePreText = callingCode

    // 获取拜访相关配置
    const initConf =  await getVisitObjectInit({
      brandId: this.visitBrand || this.$route.query.brandId,
      roleId: this.roleId,
    })
    this.visitObjectList = initConf.brandContactsList || []

    // 编辑页获取拜访详情回显表单
    if (this.isEdit) {
      const contactDetail = this.visitObjectList.find(i => i.id === this.onlyId && i.roleId === this.roleId)
      const { name, phone, email, contactTime = [], contactMode = [], roleId, id } = contactDetail

      this.formData.roleId = roleId
      this.formData.id = id
      this.formData.name = name
      this.formData.phone = String(phone || '')
      this.formData.email = email
      this.formData.contactTime = contactTime && contactTime.length
                                    ? [contactTime[0].startTime, contactTime[0].endTime]
                                    : ['', '']
      this.formData.contactMode = contactMode.map(i => i)
    }

    this.dataLoaded = true
    loading.hide()
  },
  methods: {
    async save () {
      const isValid = await this.$refs.form.validate()
      if (isValid) {
        this.loading = true
        const brandId = this.visitBrand || this.$route.query.brandId
        const { name, phone, email, contactTime = ['', ''], contactMode = [], roleId } = this.formData
        const selectedRole = this.roleList.find(role => role.value === roleId) || {}
        const roleDesc = selectedRole.text
        const params = {
          brandId,
          roleId,
          roleDesc,
          name,
          phone,
          email,
          contactTime: [{
            startTime: contactTime ? contactTime[0] : '',
            endTime: contactTime ? contactTime[1] : ''
          }],
        }
        contactMode && contactMode[0] && (params.contactMode = contactMode)
        this.onlyId && (params.id = this.onlyId)
        const res = await saveVisitObject(params)
        this.loading = false
        if (res) {
          this.$emit('save', params)
          this.$emit('back')
        }
      }
    },
    back () {
      this.$emit('back')
    },
  }
}
</script>

<style lang="scss" scoped>
.add-visit-person {
  position: relative;
  background-color: #f2f3f6;
  height: 100%;

  .notification {
    display: flex;
    align-items: center;
    width: 100%;
    background: #e9eaee;
    z-index: 1;
    text-align: left;

    p {
      flex: 1;
      padding: 24px 0 24px 40px;
      font-size: 24px;
      color: #595c66;
      line-height: 32px;
      font-weight: 400;

      .icon-outlined_information {
        margin-right: 6px;
        font-size: 32px;
        vertical-align: middle;
      }
    }

    .richic-close {
      display: flex;
      align-items: center;
      margin: 0 32px;
      flex: 0;
      font-size: 48px;
    }
  }

  &-list-wrapper {
    padding-bottom: 120px;
    background-color: #f2f3f6;
    height: calc(100vh - 100px - 152px);
    box-sizing: border-box;
    overflow: scroll;
  }

  &-form {
    margin: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: #ffffff;

    ::v-deep .rich-form-item {
      padding: 24px;

      .rich-form-label {
        font-size: 24px;
        color: #8d9099;
        line-height: 32px;
        padding-bottom: 16px;
      }
      .rich-form-field {
        font-family: DiDiSans-Pro-Medium;
        font-size: 36px;
        color: #282b33;
        line-height: 44px;
        padding-bottom: 16px;

        .rich-input-wrapper {
          height: auto;
          .rich-input-label-placeholder {
            display: none;
          }
          .rich-input-bottom {
            padding: 0;
          }
        }
      }
    }
  }

  .save {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #ffffff;
    padding: 20px 24px 40px 24px;
    box-sizing: border-box;
    &-btn {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
